import { ConstructorProvider, Injector } from '@angular/core';
import { ProtocolBaseService, ProtocolRegistry } from '@core/shared/protocol';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/protocol";
export let ProtocolService = /*#__PURE__*/(() => {
  class ProtocolService extends ProtocolBaseService {
    constructor(registry, injector) {
      super(registry);
      this.registry = registry;
      this.injector = injector;
    }
    assignLoggers(protocol, ctors) {
      const loggerCtors = [...this.registry.getDefaultLoggers(), ...(ctors || [])];
      const loggers = [];
      for (const ctor of loggerCtors) {
        loggers.push(Injector.create({
          providers: [{
            provide: ctor
          }],
          parent: this.injector
        }).get(ctor));
      }
      loggers.forEach(logger => protocol.registerLogger(logger));
    }
    static {
      this.ɵfac = function ProtocolService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProtocolService)(i0.ɵɵinject(i1.ProtocolRegistry), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ProtocolService,
        factory: ProtocolService.ɵfac
      });
    }
  }
  return ProtocolService;
})();